import { Injectable } from '@angular/core';
import { PerformanceMonitoringPortfolioGQL, PerformanceMonitoringParkGQL, PerformanceMonitoringTurbineGQL } from '../../graphql';
import {Observable, combineLatest, BehaviorSubject} from 'rxjs';
import { PerformanceMonitoring } from 'app/models/monitor/performance-monitoring.model';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable()
export class PerformanceMonitoringService {
  constructor(
    private performanceMonitoringPortfolioGQL: PerformanceMonitoringPortfolioGQL,
    private performanceMonitoringParkGQL: PerformanceMonitoringParkGQL,
    private performanceMonitoringTurbineGQL: PerformanceMonitoringTurbineGQL,
  ) { }

  public getPerformanceMonitoringPortfolioData(hoursObservable: Observable<number>,
                                               navigationDetails: NavigationDetails): Observable<PerformanceMonitoring> {
    return hoursObservable.pipe(
      distinctUntilChanged(),
      switchMap((hours) => {
              return this.performanceMonitoringPortfolioGQL.subscribe({
                variables: {
                  hours,
                  portfolioId: navigationDetails.selectedPortfolioId,
                  parkIds: navigationDetails.selectedParksIds
                }
              }).pipe(
                  map(result => PerformanceMonitoring.mapFromPortfolio(result.data.portfolios[0], hours))
              )
          }
      )
    );
  }

  public getPerformanceMonitoringParkData(hoursObservable: Observable<number>,
                                          parkNameObservable: Observable<string>,
                                          selectedTurbinesIds: string[]): Observable<any> {
    return combineLatest([
      hoursObservable,
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([hours, parkName]) => {
              return this.performanceMonitoringParkGQL.subscribe({
                variables: {
                  hours,
                  name: parkName,
                  turbineIds: selectedTurbinesIds
                }
              }).pipe(
                  map(result => PerformanceMonitoring.mapFromPark(result.data.parks[0], hours))
              )
          }
      )
    );
  }

  public getPerformanceMonitoringTurbineData(hoursObservable: Observable<number>, turbineSerialObservable: Observable<number>): Observable<PerformanceMonitoring> {
    return combineLatest([
      hoursObservable,
      turbineSerialObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([hours, turbineSerial]) =>
        this.performanceMonitoringTurbineGQL.subscribe({
          variables: {
          hours,
          serialNav: turbineSerial
          }
        }).pipe(
          map(result => PerformanceMonitoring.mapFromTurbine(result.data.turbines[0], hours))
        )
      )
    );
  }
}
